<template>
    <div>
        <v-dialog max-width="500" v-model="dialogcontent1">
            <v-card>
                <v-card-title class="headline">
                    {{ content1.title }}
                </v-card-title>
                <v-card-subtitle class="subtitle-1">
                    <p class="mt-2">
                        <v-chip small class="mr-1">{{
                            content1.created_name +
                                " : " +
                                content1.created_date
                        }}</v-chip>
                    </p>
                    {{ content1.subtitle }}
                </v-card-subtitle>
                <v-card-text class="subtitle-3" v-html="content1.content">
                </v-card-text>
                <v-container fluid>
                    <v-row v-viewer>
                        <v-col cols="3">
                            <template v-if="image.images.length > 0">
                                <view-image title="image" :data="image" />
                            </template>

                            <!-- <template v-slot:item.image="{ item }">
                <v-chip
                  v-if="item.images.length > 0"
                  @click="showImage(item.announce_id)"
                  small
                  class="mr-2 mb-2"
                >
                  <viewer
                    :images="item.images"
                    :class="'viewer' + item.announce_id"
                    :id="'viewer' + item.announce_id"
                    ref="viewer"
                    @inited="inited"
                  >
                    <img
                      v-for="src in item.images"
                      :src="src"
                      :key="src"
                      class="image"
                    />
                  </viewer>
                  <v-avatar left>
                    <v-icon small>mdi-file-image</v-icon>
                  </v-avatar>
                  View Image
                </v-chip>
              </template> -->

                            <!-- <img
                class="images"
                :src="
                  showpic1 +
                    itemeditpic.file_store_name +
                    '/' +
                    itemeditpic.file_name
                "
                width="100%"
              /> -->
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <div
                        v-for="(itemeditpic, idxeditpic) in content1.files"
                        :key="idxeditpic"
                    >
                        <v-chip
                            small
                            class="mr-2 mb-2"
                            :href="
                                showpic1 +
                                    itemeditpic.file_store_name +
                                    '/' +
                                    itemeditpic.file_name
                            "
                            target="_blank"
                        >
                            <v-avatar left>
                                <v-icon small>mdi-paperclip</v-icon> </v-avatar
                            >{{ itemeditpic.file_name }}
                        </v-chip>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancelcontent1()"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card outlined class="mx-auto">
            <v-carousel
                :continuous="true"
                :cycle="cycle"
                :show-arrows="true"
                :height="
                    team_name == 'ONSITE' ||
                    team_name == 'NONHP' ||
                    xheight == '140'
                        ? 140
                        : 220
                "
                light
                hide-delimiter-background
                delimiter-icon="mdi-minus"
                show-arrows-on-hover
            >
                <v-carousel-item v-for="(items1, i) in data1" :key="i">
                    <!-- pl-12 pr-12 -->
                    <v-sheet height="100%" class="pt-3" :color="colors[i]">
                        <v-card-title class="headline pl-10 pr-10">
                            <span class="fix-color-font">{{
                                items1.title
                            }}</span>
                        </v-card-title>
                        <v-card-subtitle
                            class="subtitle-1 pl-10 pr-10"
                            v-if="team_name != 'ONSITE'"
                        >
                            <!-- items1.subtitle -->
                            <span class="fix-color-font">{{
                                items1.created_name +
                                    " - " +
                                    items1.created_date
                            }}</span>
                        </v-card-subtitle>
                        <v-card-actions class="pl-10 pr-10">
                            <v-chip
                                @click="showcontent1(items1)"
                                small
                                :class="
                                    team_name == 'ONSITE'
                                        ? 'mr-2 mb- mar-t-15'
                                        : 'mr-2 mb-2'
                                "
                            >
                                <v-avatar left>
                                    <v-icon small>mdi-content-duplicate</v-icon>
                                </v-avatar>
                                View more
                            </v-chip>
                        </v-card-actions>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"
import Image from "../../../components/ViewImage"
export default {
    props: ["xheight"],
    components: {
        "view-image": Image,
    },
    mounted() {
        this.getAjax1()
    },
    data() {
        return {
            team_name: localStorage.team_name,
            showpic1: `${process.env.VUE_APP_ROOT_API}/api/announce/attachments/`,
            image: {
                images: [],
            },
            data1: [],
            edit1: [],
            content1: [],
            apilink: "",
            view: [],
            dialogimg1: false,
            dialogcontent1: false,
            colors: [
                "#78adcf",
                "#6cb2ba",
                "#78adcf",
                "#6cb2ba",
                "#78adcf",
                "#6cb2ba",
                "#78adcf",
                "#6cb2ba",
            ],
            cycle: true,
            slides: ["First", "Second", "Third", "Fourth", "Fifth"],
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        inited(viewer) {
            this.view.push(viewer)
        },
        showImage(id) {
            this.view.map((each) => {
                if (each.element.id == "viewer" + id) {
                    this.$viewer = each
                    this.$viewer.show()
                }
            })
        },
        showcontent1(a) {
            this.dialogcontent1 = true
            this.content1 = { ...a }
            this.image.images = []
            a.images.map((each) => {
                this.image.images.push(each)
            })

            // console.log(this.content1, "content1");
            // console.log(this.image, "image");
        },
        cancelcontent1() {
            this.content1 = []
            this.dialogcontent1 = false
        },

        async getAjax1() {
            var tk = localStorage.token !== undefined ? localStorage.token : " "
            const options = {
                headers: {
                    Authorization: "Bearer " + tk,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/announce-active`
            // try {
            // this.mutateIsLoading()
            await axios
                .get(url, options)
                .then((response) => {
                    response.data.map((each) => {
                        var ob = [...each.images]
                        this.image.images = []
                        ob.map((src) => {
                            this.image.images.push(
                                this.showpic1 +
                                    src.file_store_name +
                                    "/" +
                                    src.file_name
                            )
                        })
                        this.data1.push(Object.assign({}, each, this.image))
                    })
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })

            // console.log(this.data1, "data1");
            // this.mutateIsLoading()
            // } catch (error) {
            //     console.log(error)
            // }
        },
    },
}
</script>

<style scoped>
.image {
    display: none;
}
.fix-color-font {
    color: #fff !important;
}
</style>
